import { TextField } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import InputMask from "react-input-mask";
import moment from "moment"

const InvoiceDate = () => {
  const { values, handleChange, handleBlur, touched, errors } =
    useFormikContext();

  const { invoice_date = "" } = values;
  return (
    <InputMask
      mask="99/99/9999"
      value={invoice_date}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={(e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("Text");
        const fieldName = e.target.name;
        handleChange({
          target: {
            name: fieldName,
            value: moment(pastedData).format("MM/DD/YYYY"),
          },
        });
      }}
    >
      {() => (
        <TextField
          label="Invoice Date"
          error={touched.invoice_date && Boolean(errors.invoice_date)}
          helperText={touched.invoice_date && errors.invoice_date}
          required
          size="small"
          name="invoice_date"
        />
      )}
    </InputMask>
  );
};

export default InvoiceDate;
